import type { Dispatch, SetStateAction } from 'react';

import type { DocumentItem } from 'hb-react/backoffice/types/builder/builderDocument';

const handleChildrenPosition = (
  itemId: string,
  overItemId: string,
  parentColumn: DocumentItem,
) => {
  if (!parentColumn.children) return;

  const isOnlyChild = parentColumn.children.length === 1;
  let isFirstChild = false;
  let isLastChild = false;

  if (!isOnlyChild) {
    isFirstChild =
      parentColumn.children[0].id === itemId
        ? parentColumn.children[1].id === overItemId
        : parentColumn.children[0].id === overItemId;
    isLastChild =
      parentColumn.children[parentColumn.children.length - 1].id === itemId
        ? parentColumn.children[parentColumn.children.length - 2].id ===
          overItemId
        : parentColumn.children[parentColumn.children.length - 1].id ===
          overItemId;
  }

  return {
    isFirstChild,
    isLastChild,
    isOnlyChild,
  };
};

interface HandleTopOrBottomCompoProps {
  isCompoBottom: boolean;
  isCompoTop: boolean;
  item: DocumentItem;
  overItem: DocumentItem;
  parentSection: DocumentItem;
  parentColumn: DocumentItem;
  setOverSectionDirection: Dispatch<SetStateAction<{ [id: string]: string }>>;
}

// Function to know if we have to apply the margin top or bottom on the hovered component
// in order to create a new section
export const handleTopOrBottomCompo = ({
  isCompoBottom,
  isCompoTop,
  item,
  overItem,
  parentSection,
  parentColumn,
  setOverSectionDirection,
}: HandleTopOrBottomCompoProps) => {
  const children = handleChildrenPosition(item?.id, overItem.id, parentColumn);

  if (!children) return;

  const { isFirstChild, isLastChild, isOnlyChild } = children;

  if (isOnlyChild) {
    const direction = isCompoTop ? 'marginTop' : 'marginBottom';

    setOverSectionDirection({
      [parentSection.id]: direction,
    });
  }

  if (isFirstChild || isLastChild) {
    // We have to know if we are at the top of the first child or at the bottom or the last child
    // to apply the margin on the section
    const isTopFirstChild = isFirstChild && isCompoTop;
    const isBottomLastChild = isLastChild && isCompoBottom;

    if (isTopFirstChild || isBottomLastChild) {
      const direction = isTopFirstChild ? 'marginTop' : 'marginBottom';

      setOverSectionDirection({
        [parentSection.id]: direction,
      });
    }
  }
};
